import { Controller } from '@hotwired/stimulus'
import SignaturePad from 'signature_pad'

export default class extends Controller {
  static targets = ['canvas', 'input']

  clear() {
    this.signaturePad.clear()
    this.inputTarget.value = ''
  }

  endStroke = (_) => {
    this.inputTarget.value = this.signaturePad.toDataURL('image/svg+xml')
  }

  resizeCanvas() {
    // When zoomed out to less than 100%, for some very strange reason,
    // some browsers report devicePixelRatio as less than 1
    // and only part of the canvas is cleared then.
    var ratio = Math.max(window.devicePixelRatio || 1, 1)

    // This part causes the canvas to be cleared
    this.canvasTarget.width = this.canvasTarget.offsetWidth * ratio
    this.canvasTarget.height = this.canvasTarget.offsetHeight * ratio
    this.canvasTarget.getContext('2d').scale(ratio, ratio)

    // This library does not listen for canvas changes, so after the canvas is automatically
    // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
    // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
    // that the state of this library is consistent with visual state of the canvas, you
    // have to clear it manually.
    // this.clear()

    // If you want to keep the drawing on resize instead of clearing it you can reset the data.
    this.signaturePad.redraw()
  }

  connect() {
    this.boundResizeCanvas = this.resizeCanvas.bind(this)
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: 'rgb(255, 255, 255)',
      minWidth: 1,
      maxWidth: 2
    })
    this.signaturePad.addEventListener('endStroke', this.endStroke)
    window.addEventListener('resize', this.boundResizeCanvas)
    this.resizeCanvas()
    this.clear()
  }

  disconnect() {
    this.signaturePad.removeEventListener('endStroke', this.endStroke)
    window.removeEventListener('resize', this.boundResizeCanvas)
    this.signaturePad.off()
  }
}
